/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostFreeTrialBody
 */
export interface PostFreeTrialBody {
    /**
     * 企業ID
     * @type {number}
     * @memberof PostFreeTrialBody
     */
    companyId: number;
    /**
     * クリップID
     * @type {number}
     * @memberof PostFreeTrialBody
     */
    clipId: number;
}

export function PostFreeTrialBodyFromJSON(json: any): PostFreeTrialBody {
    return PostFreeTrialBodyFromJSONTyped(json, false);
}

export function PostFreeTrialBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFreeTrialBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'clipId': json['clip_id'],
    };
}

export function PostFreeTrialBodyToJSON(value?: PostFreeTrialBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'clip_id': value.clipId,
    };
}

